var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ce-resultStateIndicators"},[(_vm.showNew)?_c('div',{staticClass:"ce-resultStateIndicators--new"}):_vm._e(),_vm._v(" "),(_vm.showUpdated)?_c('div',{staticClass:"ce-resultStateIndicators--updated"}):_vm._e()])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }